<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3>Welcome {{ firstName }} {{ lastName }}</h3>
        <button
          class="btn btn-primary"
          style="position: absolute; top: 0; right: 0;"
          v-on:click="updateUser"
        >
          Save Changes
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-0" />
      <div class="col-md-6 col-12">
        <h5 class="mt-2">First Name</h5>
        <input type="text" class="form-control" v-model="firstName" />
        <h5 class="mt-2">Last Name</h5>
        <input type="text" class="form-control" v-model="lastName" />
        <h5 class="mt-2">Email Address</h5>
        <input type="email" class="form-control" v-model="email" disabled />
        <h5 class="mt-2">Phone Number</h5>
        <input
          type="text"
          class="form-control"
          id="phone"
          placeholder="Enter Numbers Only"
          v-model="phone"
        />
      </div>
      <div class="col-md-3 col-0" />
    </div>
    <div class="row mt-4">
      <div class="col">
        <h5>Preferences</h5>
      </div>
    </div>
    <GrantCategorization
      v-bind:UserPreferences="user"
      @categorizationChange="categorizationChanged"
      ElementIdSuffix="Preferences"
    />
  </div>
</template>

<script>
import GrantCategorization from "@/components/ManageGrants/GrantCategorization.vue";
//import $ from "jquery";

export default {
  name: "UserPreferences",
  components: {
    GrantCategorization
  },
  data() {
    return {
      teachingSubject: [],
      teachingGrade: [],
      awardLevel: [],
      firstName: this.$store.getters.user.First_Name,
      lastName: this.$store.getters.user.Last_Name,
      email: this.$store.getters.user.Email,
      phone: this.$store.getters.user.Phone,
      user: {}
    };
  },
  mounted() {
    this.user = this.$store.getters.user;
  },
  methods: {
    async updateUser() {
      var view = this;
      view.$store.commit("updateLoading", true);

      var userToUpdate = {
        userId: parseInt(view.$store.getters.user.User_Id),
        firstName: view.$data.firstName,
        lastName: view.$data.lastName,
        email: view.$data.email.toLowerCase(),
        phone: view.$data.phone,
        teachingGrade: view.$data.teachingGrade,
        teachingSubject: view.$data.teachingSubject,
        awardLevel: view.$data.awardLevel
      };
      await view
        .$updateUser(userToUpdate)
        .then(updatedUser => {
          view.$store.commit("updateUser", updatedUser);
          view.$store.commit("updateLoading", false);
          view.$showSnackbar("Your profile has been saved.", false);
        })
        .catch(err => {
          console.log(err);
          view.$store.commit("updateLoading", false);
          view.$showSnackbar(
            "Something went wrong, please try again later.",
            false
          );
        });
    },
    categorizationChanged(categorization) {
      this.teachingGrade = categorization.teachingGrade;
      this.teachingSubject = categorization.teachingSubject;
      this.awardLevel = categorization.awardLevel;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
